import ChannelListContext from '@shared/components/utils/context/channelListContext';
import ChannelListScoreContainer from '@components/atoms/container/channelListScoreContainer';
import ChannelListServicesContainer from '../../atoms/container/channelListServicesContainer';
import FlavourConfig from '../../../../shared/config/flavours';
import Logo from '../../atoms/images/iGuideLogo';
import Score from '../rating/score';
import Services from '../services/services';
import { useContext } from 'react';

interface Props {
  score?: number;
}

export default function ChannelListServices({ score }: Props) {
  const { channel } = useContext(ChannelListContext);
  return (
    <ChannelListServicesContainer id={'ChannelListServicesContainer'}>
      {FlavourConfig.capabilities.showIGuideTv ? <Logo /> : null}
      <div style={{ display: 'flex' }}>
        <Services channel={channel} />
      </div>
      <ChannelListScoreContainer>
        <Score score={score?.toString()} />
      </ChannelListScoreContainer>
    </ChannelListServicesContainer>
  );
}
